module.exports = __webpack_public_path__ + "media/src/images/top_covers/April_04-1fea39b885130d2d88bd79e421271788.png";